export function findItemInChildArray (obj, predicate, childProperty) {
  if (!obj) {
    return obj
  }

  let array = obj[childProperty]

  if (array) {
    const item = array.find(predicate)

    if (item) {
      return item
    }

    for (let i = 0; i < array.length; i++) {
      return findItemInChildArray(array[i], predicate, childProperty)
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/util.js